export const MAX_LUMINANCE_FOR_LIGHT_TEXT = 160
